/* Import Section - Start */
/* React Imports - Start */
import React, { useState, useEffect, forwardRef, useRef } from "react";
import { useIsEdited } from "../../Providers/IsEditedProvider";
/* React Imports - End */
/* Import Section - End */

/* Plugin Imports - Start */
import { InputTextarea } from "primereact/inputtextarea";
/* Plugin Imports - End */

/* Function - Start */
const TextareaElement = forwardRef((props,ref) => {
  /* State Declaration - Start */
  /* useState - Start */
  const [inputValue, setInputValue] = useState(" ");
  /* useState - End */
  /* State Declaration - End */
  const debounceTimeoutRef = useRef(null);
  const { setIsEdited } = useIsEdited();

  useEffect(() => {
    if (props?.value && props.value !== inputValue ){
      setInputValue(props.value ? props.value : "");
    } else {
      if (props?.defaultValue && props.defaultValue !== inputValue) {
        setInputValue(props.defaultValue ? props.defaultValue : "");
      }
    }
  }, [props?.value, props?.defaultValue]);

  /* Methods - Start */
  const onValueChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue); // Update state immediately

    // Clear any existing debounce timeout
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set a new debounce timeout with time delay
    debounceTimeoutRef.current = setTimeout(() => {
      if (props.onChange) {
        props.onChange(e); 
        setIsEdited(true);
      }
    }, 500);
  };
  /* Methods - End */

  /* Render View Return - Start */
  return (
    <div>
      <InputTextarea
        key={props.name}
        name={props.name}
        value={inputValue}
        // defaultValue={props.defaultValue}
        ref={ref}
        rows={props.rows}
        cols={props.cols}
        onChange={onValueChange}
        placeholder={props.placeholder}
        className={props.className}
        disabled={props.disabled ? props.disabled : false}
        register={props.register}
      ></InputTextarea>
    </div>
  );
  /* Render View Return - End */
});
/* Function - End */
/* Export default functionName; */
export default TextareaElement;